import React, { useEffect } from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import Button from "Components/common/Button";

class ExportToZohoPopupState {
  @observable showPopup = false;
  @observable btnLoader = false;
  @observable defaultObj = {};
  @observable selectedKey = "lead";

  @action
  setShowPopup = (value = false) => {
    this.showPopup = value;
  };

  @action
  setBtnLoader = (value = false) => {
    this.btnLoader = value;
  };

  @action
  setDefaultObj = (value = {}) => {
    this.defaultObj = value;
  };

  @action
  setSelectedKey = (value = "") => {
    this.selectedKey = value;
  };
}

const exportToZohoPopupState = new ExportToZohoPopupState();

const ExportToZohoPopup = observer(() => {
  const handleExportAction = () => {
    exportToZohoPopupState.setBtnLoader(true);
    exportToZohoPopupState.defaultObj.cbk(exportToZohoPopupState?.selectedKey);
  };

  const closePopup = () => {
    exportToZohoPopupState.setSelectedKey("lead");
    exportToZohoPopupState.setShowPopup(false);
  };

  const handleSelectAction = (value = "") => {
    exportToZohoPopupState.setSelectedKey(value);
  };

  const exportBtn = {
    id: "exportBtn",
    name: "exportBtn",
    btnText: "Export",
    type: "button",
    loader: exportToZohoPopupState?.btnLoader || false,
    className: `exportToSalesforceBtn ${
      exportToZohoPopupState?.btnLoader ? "loading" : ""
    }`,
    click: handleExportAction
  };

  return exportToZohoPopupState.showPopup ? (
    <div className="exportToZohoPopup">
      <div
        className={`card animated customzoomIn ${
          exportToZohoPopupState?.btnLoader ? "disableClick" : ""
        }`}
      >
        <div className="cardHeader">
          <div className="textWrapper">
            <div className="title">{`Export to Zoho`}</div>
          </div>
          <i className="material-icons close" onClick={closePopup}>
            close
          </i>
        </div>
        <div className="cardBody">
          <div className="exportListWrapper">
            <div className="title">{`Select export as`}</div>
            <div className="exportList">
              {exportConfig.map(member => (
                <div
                  className={`options ${
                    member?.key === exportToZohoPopupState?.selectedKey
                      ? "activeMember"
                      : ""
                  }`}
                >
                  <div className="radioBtnCont">
                    <div className="radioButtonCont">
                      <input
                        type="radio"
                        name="addToListRadioCheckbox"
                        id={member?.key}
                        onChange={() => handleSelectAction(member?.key)}
                        checked={
                          member?.key === exportToZohoPopupState?.selectedKey
                        }
                        className="radioBtn"
                      />
                      <span className="contentClass" />
                    </div>
                  </div>
                  <label className="teamMemberName" htmlFor={member?.key}>
                    {member?.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <Button {...exportBtn} />
        </div>
      </div>
      <div className="overlay" />
    </div>
  ) : (
    ""
  );
});

const exportConfig = [
  {
    name: "Lead",
    key: "lead"
  },
  {
    name: "Contact",
    key: "contact"
  }
];

export default ExportToZohoPopup;
export { ExportToZohoPopup, exportToZohoPopupState };
